export const NAVIGATION_RESET = 'NAVIGATION_RESET';

export const NAVIGATE = 'NAVIGATE';

export const INVALID_SUBMIT = 'INVALID_SUBMIT';
export const VALID_SUBMIT = 'VALID_SUBMIT';

export const INVALIDATE_FORM = 'INVALIDATE_FORM';
export const VALIDATE_FORM = 'VALIDATE_FORM';



// WEBPACK FOOTER //
// ./src/constants/actions/NavigationActionTypes.js